// Level hierarchies (design README §8). Mirrors LevelHierarchies::CONFIG in
// Rails and lib/models/level_hierarchy.dart in the app. Never render a raw
// level key — always go through levelLabel / levelPlural.

export interface LevelDef { key: string; label: string; plural: string; emoji: string }
export interface Hierarchy { key: string; label: string; levels: LevelDef[] }

const L = (key: string, label: string, plural: string, emoji: string): LevelDef => ({ key, label, plural, emoji });

export const HIERARCHIES: Record<string, Hierarchy> = {
  farm_field: { key: "farm_field", label: "Farm / Field", levels: [L("farm", "Farm", "Farms", "🐄"), L("field", "Field", "Fields", "🌾")] },
  client_farm: { key: "client_farm", label: "Client / Farm", levels: [L("client", "Client", "Clients", "🏢"), L("farm", "Farm", "Farms", "🐄")] },
  entity_farm_tract_field: {
    key: "entity_farm_tract_field",
    label: "Entity / Farm / Tract / Field",
    levels: [L("entity", "Entity", "Entities", "🏢"), L("farm", "Farm", "Farms", "🐄"), L("tract", "Tract", "Tracts", "📐"), L("field", "Field", "Fields", "🌾")],
  },
  dealer_agent_account_machine: {
    key: "dealer_agent_account_machine",
    label: "Dealer / Agent / Account / Machine",
    levels: [L("dealer_area", "Dealer Area", "Dealer Areas", "🏬"), L("agent_area", "Agent Area", "Agent Areas", "👤"), L("key_account", "Key Account", "Key Accounts", "📍"), L("machine", "Machine", "Machines", "🚜")],
  },
};

export const hierarchyFor = (key?: string | null) => HIERARCHIES[key ?? ""] ?? HIERARCHIES.farm_field;

export function levelDef(levelKey?: string | null, hierarchyKey?: string | null): LevelDef {
  const h = hierarchyFor(hierarchyKey);
  return h.levels.find((l) => l.key === levelKey)
    ?? Object.values(HIERARCHIES).flatMap((x) => x.levels).find((l) => l.key === levelKey)
    ?? L(levelKey ?? "location", "Location", "Locations", "📍");
}
export const levelLabel = (k?: string | null, h?: string | null) => levelDef(k, h).label;
export const levelPlural = (k?: string | null, h?: string | null) => levelDef(k, h).plural;
